import { OrderPriceNegotiationStatus } from '@/interface/order';
import i18n from '@/i18n';
import {
  YouTubeIcon,
  connectSocialIcon,
  EmailInvitesIcon,
  ResponseInvitesIcon,
  CreateSubmitIcon,
  PublishRewardsIcon,
  AhaSupportIcon,
  CommunityIcon,
  BookOpenIcon
} from '@/components/common/icon';
import { SubmitStatusEnum } from '../config';
import { getShowScript } from '@/biz/order';
import { AdsCampaignMarketingStrategy } from '@/interface/campaign';

// HANS_TODO:这里文案 图片 要改
export const creatorStepsItems = [
  {
    Icon: connectSocialIcon,
    title: i18n.t('home.creator_steps.step1.title', {
      defaultValue: 'Connect your social account'
    }),
    desc: i18n.t('home.creator_steps.step1.desc', {
      defaultValue:
        'Connect more social accounts to get more cooperation opportunities!'
    })
  },
  {
    Icon: EmailInvitesIcon,
    title: i18n.t('home.creator_steps.step2.title', {
      defaultValue: 'Keep an eye on email invites'
    }),
    desc: i18n.t('home.creator_steps.step2.desc', {
      defaultValue:
        'Most brand deals are highly competitive. Make sure to respond promptly!'
    })
  },
  {
    Icon: ResponseInvitesIcon,
    title: i18n.t('home.creator_steps.step3.title', {
      defaultValue: 'Respond to new invites'
    }),
    desc: i18n.t('home.creator_steps.step3.desc', {
      defaultValue:
        "Join deals you're interested in early — spots fill up fast!"
    })
  },
  {
    Icon: CreateSubmitIcon,
    title: i18n.t('home.creator_steps.step4.title', {
      defaultValue: 'Create and submit content'
    }),
    desc: i18n.t('home.creator_steps.step4.desc', {
      defaultValue: 'Follow the content requirements and submit it for review.'
    })
  },
  {
    Icon: PublishRewardsIcon,
    title: i18n.t('home.creator_steps.step5.title', {
      defaultValue: 'Publish and earn rewards'
    }),
    desc: i18n.t('home.creator_steps.step5.desc', {
      defaultValue: 'Post approved content and claim your well-earned reward!'
    })
  }
];

export const resourcesItems = [
  {
    Icon: AhaSupportIcon,
    title: i18n.t('home.resources.support.title', {
      defaultValue: 'Contact your AhaCreator support'
    }),
    desc: i18n.t('home.resources.support.desc', {
      defaultValue:
        'As a new creator, you have access to our specialized support service.'
    }),
    link: 'mailto:support@creator.aha.inc'
  },
  {
    Icon: BookOpenIcon,
    title: i18n.t('home.resources.helpCenter.title', {
      defaultValue: 'Creator Help Center'
    }),
    desc: i18n.t('home.resources.helpCenter.desc', {
      defaultValue: 'Quick answers and guides for creators.'
    }),
    link: 'https://chartreuse-wrinkle-697.notion.site/Creator-Help-Center-11804daded68800baa1bdea90409a469'
  }
  // {
  //   Icon: CommunityIcon,
  //   title: 'Join the community',
  //   desc: 'Join Aha discord channel for more discussions and events!',
  //   link: 'https://discord.com/invite/EtcfjsFWq4'
  // }
];

/**
 * displayStatus 的枚举
 */
export enum ActionsStatusEnum {
  CreatorApplied = 'Creator_applied',
  ApplyRejected = 'Apply_rejected',
  PendingProductionKickoff = 'Pending_production_kickoff', // 非寄样-待确认
  UnderScriptProduction = 'Under_script_production',
  UnderScriptReview = 'Under_script_review', // 达人制作脚本
  UnderVideoProduction = 'Under_video_production', // 达人制作视频
  UnderVideoReview = 'Under_video_review',
  PendingPublish = 'Pending_publish',
  ReviewRejected = 'Review_rejected',
  PublishRejected = 'Publish_rejected',
  PendingPayment = 'Pending_payment',
  PaymentSubmitted = 'Payment_submitted',
  Paid = 'Paid',
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  PendingProductShipment = 'Pending_Product_shipment', // 待发货
  PendingProductArrival = 'Pending_Product_Arrival', // 发货中
  Pending = 'Pending', // 资源池
  PendingCreatorAddress = 'Pending_creator_address', // 待达人填写地址
  PendingCreatorAccountInfo = 'Pending_creator_account_info', // 待达人填写账号信息
  PendingAccountSetup = 'Pending_account_setup' // 待广告主设置账号
}

export const actionsStatusLab: any = {
  [ActionsStatusEnum.UnderScriptProduction]: SubmitStatusEnum.script,
  [ActionsStatusEnum.UnderVideoProduction]: SubmitStatusEnum.video,
  [ActionsStatusEnum.PublishRejected]: SubmitStatusEnum.finalLink,
  [ActionsStatusEnum.PendingPublish]: SubmitStatusEnum.finalLink,
  [ActionsStatusEnum.PendingProductionKickoff]: SubmitStatusEnum.receivePayment,
  [ActionsStatusEnum.PendingCreatorAddress]: SubmitStatusEnum.address,
  [ActionsStatusEnum.PendingCreatorAccountInfo]: SubmitStatusEnum.AccountInfo
};

export const actionsSubmitLab: any = {
  [ActionsStatusEnum.CreatorApplied]: i18n.t(
    'home.actions.submit.price_under_negotiation',
    {
      defaultValue: 'Price under negotiation'
    }
  ),
  [ActionsStatusEnum.PendingProductionKickoff]: i18n.t(
    'home.actions.submit.kickoff',
    {
      defaultValue: 'Kickoff content production'
    }
  ),
  [ActionsStatusEnum.UnderScriptProduction]: i18n.t(
    'home.actions.submit.script',
    {
      defaultValue: 'Submit idea/script'
    }
  ),
  [ActionsStatusEnum.UnderVideoProduction]: i18n.t(
    'home.actions.submit.draft',
    {
      defaultValue: 'Submit draft'
    }
  ),
  [ActionsStatusEnum.PendingPublish]: i18n.t('home.actions.submit.final', {
    defaultValue: 'Submit final link'
  }),
  [ActionsStatusEnum.PendingCreatorAddress]: i18n.t(
    'home.actions.submit.address',
    {
      defaultValue: 'Complete redemption info'
    }
  ),
  [ActionsStatusEnum.PendingCreatorAccountInfo]: i18n.t(
    'home.actions.submit.account',
    {
      defaultValue: 'Submit account details'
    }
  )
};

export const getDealsStatus: any = ({ order }: { order: any }) => {
  const isAffiliates =
    order?.marketingStrategy ===
    AdsCampaignMarketingStrategy.AFFILIATES_MARKETING;

  const showScript = getShowScript(order);
  const displayStatus = order?.displayStatus;
  const orderCancelType = order?.cancelType;

  // type值对应项目中的状态样式颜色 3 绿色 2 蓝色 1 橙色 4 黑色 5 紫色
  const dealsStatusLab = {
    [ActionsStatusEnum.CreatorApplied]: {
      text:
        order?.priceNegotiationStatus ===
        OrderPriceNegotiationStatus.UnderCreatorReview
          ? i18n.t('home.deals.status.review_needed', {
              defaultValue: 'Review needed'
            })
          : i18n.t('home.deals.status.waiting_for_brand_approval', {
              defaultValue: 'Waiting for brand approval'
            }),
      type: 5
    },
    [ActionsStatusEnum.ApplyRejected]: {
      text: i18n.t('home.deals.status.canceled', {
        defaultValue: 'Deal canceled'
      }),
      type: 4
    },
    [ActionsStatusEnum.PendingProductionKickoff]: {
      text: i18n.t('home.deals.status.pending_kickoff', {
        defaultValue: 'Pending production kickoff'
      }),
      type: 3
    },
    [ActionsStatusEnum.PendingCreatorAddress]: {
      text: i18n.t('home.deals.status.pending_address', {
        defaultValue: 'Pending shipment address'
      }),
      type: 3
    },
    [ActionsStatusEnum.PendingCreatorAccountInfo]: {
      text: i18n.t('home.deals.status.pending_submit_account', {
        defaultValue: 'Pending account details'
      }),
      type: 3
    },
    [ActionsStatusEnum.PendingAccountSetup]: {
      text: i18n.t('home.deals.status.pending_setup_account', {
        defaultValue: 'Access setup in progress'
      }),
      type: 2
    },

    [ActionsStatusEnum.UnderScriptProduction]: {
      text: i18n.t('home.deals.status.approved', {
        defaultValue: 'Application approved'
      }),
      type: 3
    },
    [ActionsStatusEnum.UnderScriptReview]: {
      text: i18n.t('home.deals.status.script_review', {
        defaultValue: 'Under script review'
      }),
      type: 2
    },
    [ActionsStatusEnum.UnderVideoProduction]: {
      text: showScript
        ? i18n.t('home.deals.status.script_approved', {
            defaultValue: 'Script approved'
          })
        : i18n.t('home.deals.status.approved', {
            defaultValue: 'Application approved'
          }),
      type: 3
    },
    [ActionsStatusEnum.UnderVideoReview]: {
      text: i18n.t('home.deals.status.video_review', {
        defaultValue: 'Under video review'
      }),
      type: 2
    },
    [ActionsStatusEnum.PendingPublish]: {
      text: isAffiliates
        ? i18n.t('home.deals.status.pending_publish', {
            defaultValue: 'Pending Publish'
          })
        : i18n.t('home.deals.status.video_approved', {
            defaultValue: 'Video approved'
          }),
      type: 3
    },
    [ActionsStatusEnum.ReviewRejected]: {
      // 提交了不能通过的连接
      text: isAffiliates
        ? i18n.t('home.deals.status.pending_publish', {
            defaultValue: 'Pending Publish'
          })
        : i18n.t('home.deals.status.video_approved', {
            defaultValue: 'Video approved'
          }),
      type: 3
    },
    [ActionsStatusEnum.PublishRejected]: {
      text: isAffiliates
        ? i18n.t('home.deals.status.pending_publish', {
            defaultValue: 'Pending Publish'
          })
        : i18n.t('home.deals.status.video_approved', {
            defaultValue: 'Video approved'
          }),
      type: 3
    },
    [ActionsStatusEnum.PendingPayment]: {
      text: i18n.t('home.deals.status.under_payment', {
        defaultValue: 'Under payment'
      }),
      type: 2
    },
    [ActionsStatusEnum.PaymentSubmitted]: {
      text: i18n.t('home.deals.status.under_payment', {
        defaultValue: 'Under payment'
      }),
      type: 2
    },
    [ActionsStatusEnum.Paid]: {
      text: i18n.t('home.deals.status.payment_succeed', {
        defaultValue: 'Payment succeed'
      }),
      type: 2
    },
    [ActionsStatusEnum.Completed]: {
      text: i18n.t('home.deals.status.finished', {
        defaultValue: 'Finished'
      }),
      type: 2
    },
    [ActionsStatusEnum.Cancelled]: {
      text: i18n.t('home.deals.status.canceled', {
        defaultValue: 'Deal canceled'
      }),
      type: 4
    },
    [ActionsStatusEnum.PendingProductShipment]: {
      text: i18n.t('home.deals.status.pending_shipment', {
        defaultValue: 'Pending product shipment'
      }),
      type: 2
    },
    [ActionsStatusEnum.PendingProductArrival]: {
      text: i18n.t('home.deals.status.pending_arrival', {
        defaultValue: 'Pending product arrival'
      }),
      type: 2
    }
  };

  if (displayStatus === ActionsStatusEnum.Cancelled) {
    if (orderCancelType === 'Creator_withdraw') {
      return {
        text: i18n.t('home.deals.status.withdrawn', {
          defaultValue: 'Deal withdrawn'
        }),
        type: 4
      };
    }
  }
  return dealsStatusLab[displayStatus as keyof typeof dealsStatusLab];
};
